import { createContext, useContext } from 'react';
import { useRequestDataSourceReloadDispatcher } from './reducer';
import { RefreshTimeout } from '../../enums/refresh-timeout';
export var buildInitialState = function buildInitialState(props) {
  var _props$levelResource$, _props$levelResource, _props$levelResource$2, _props$levelResource2, _props$levelResource3, _props$defaultPageSiz, _props$defaultSorting, _props$refreshTimeout;
  var filterValues = {};
  if (props.defaultFilters) {
    var _Object$keys;
    (_Object$keys = Object.keys(props.defaultFilters)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (key) {
      filterValues[key] = props.defaultFilters[key];
    });
  }
  return {
    id: props.id,
    instanceId: btoa("".concat(props.id, "|").concat((_props$levelResource$ = (_props$levelResource = props.levelResource) === null || _props$levelResource === void 0 ? void 0 : _props$levelResource.level) !== null && _props$levelResource$ !== void 0 ? _props$levelResource$ : 'root', "|").concat((_props$levelResource$2 = (_props$levelResource2 = props.levelResource) === null || _props$levelResource2 === void 0 ? void 0 : _props$levelResource2.id) !== null && _props$levelResource$2 !== void 0 ? _props$levelResource$2 : 0)),
    levelResource: (_props$levelResource3 = props.levelResource) !== null && _props$levelResource3 !== void 0 ? _props$levelResource3 : {
      level: 'root',
      id: 0
    },
    loading: false,
    dataSource: [],
    dataSourceLoading: false,
    table: {
      pagination: {
        current: 1,
        pageSize: (_props$defaultPageSiz = props.defaultPageSize) !== null && _props$defaultPageSiz !== void 0 ? _props$defaultPageSiz : 15
      },
      sorter: (_props$defaultSorting = props.defaultSorting) !== null && _props$defaultSorting !== void 0 ? _props$defaultSorting : undefined
    },
    selectedIds: [],
    filterValues: filterValues,
    refreshing: false,
    refreshEnabled: true,
    refreshTimeout: (_props$refreshTimeout = props.refreshTimeout) !== null && _props$refreshTimeout !== void 0 ? _props$refreshTimeout : RefreshTimeout.FIVE_MINUTES,
    refreshRequested: false,
    autoRefreshRequested: false,
    refreshTimestampUpdateHandler: function refreshTimestampUpdateHandler() {}
  };
};
export var DataViewContext = createContext(null);
export var useDataViewContext = function useDataViewContext() {
  var _ref = useContext(DataViewContext),
    state = _ref.state,
    dispatch = _ref.dispatch;
  return [state, dispatch, useRequestDataSourceReloadDispatcher(dispatch)];
};